var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.866,
    height: 18.158,
    viewBox: "0 0 18.866 18.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logout",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Logout-2",
    "data-name": "Logout",
    d: "M4.1,18.158A4.069,4.069,0,0,1,0,14.127V4.04A4.079,4.079,0,0,1,4.111,0H8.618a4.067,4.067,0,0,1,4.093,4.031V8.38H7.168a.7.7,0,1,0,0,1.4h5.542v4.34A4.079,4.079,0,0,1,8.6,18.158Zm10.916-5.946a.7.7,0,0,1,0-.99l1.453-1.444H12.711V8.38h3.759L15.017,6.936a.7.7,0,0,1,0-.99.694.694,0,0,1,.99-.009L18.658,8.58a.7.7,0,0,1,.208.5.673.673,0,0,1-.208.49l-2.651,2.642a.692.692,0,0,1-.99,0Z",
    transform: "translate(0)",
    fill: "#727272"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.2ed2b7d01015ea60019df984b0d45528.svg";
export { ForwardRef as ReactComponent };